import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Outlet } from '@tanstack/react-router';
import { useState, type ReactNode } from 'react';
import { sessionQuery } from '../lib/session.js';
import { RootConsole } from './root-console.js';
import { TimeZoneSettings } from './time-zone-settings.js';
import { useLogout } from './use-logout.js';

/// A casca do console montada com sessão, fuso e saída.
///
/// O miolo é o `<Outlet/>` da rota — menos quando alguém entrega `content`, que hoje é só o 404: a
/// tela de endereço inexistente não é filha de nenhuma seção, mas continua precisando do menu ao
/// lado.
export function ConsoleLayout({ content }: { content?: ReactNode }) {
  const queryClient = useQueryClient();
  const session = useQuery(sessionQuery);
  const logout = useLogout();
  const [timeZoneSettingsOpen, setTimeZoneSettingsOpen] = useState(false);

  /// O portão da rota já provou que existe sessão. Este retorno cobre o instante entre sair e ser
  /// levado para o login, e não é tela: pintar "carregando" aqui piscaria no meio de um logout que
  /// já deu certo.
  if (!session.data) return null;

  return (
    <>
      <RootConsole
        user={session.data}
        content={content ?? <Outlet />}
        onOpenTimeZoneSettings={() => setTimeZoneSettingsOpen(true)}
        onLogout={logout}
      />
      <TimeZoneSettings
        open={timeZoneSettingsOpen}
        onOpenChange={setTimeZoneSettingsOpen}
        user={session.data}
        onSaved={async () => {
          await queryClient.invalidateQueries({ queryKey: sessionQuery.queryKey });
        }}
      />
    </>
  );
}
